import { useEffect, useRef, useState } from 'react';
import { useHealth } from '../state/health.js';

export function HealthBanner() {
  const { aiState, health, lastError } = useHealth();
  const wasDown = useRef(false);
  const [recovered, setRecovered] = useState(false);
  useEffect(() => {
    if (aiState === 'unavailable' || (aiState === 'loading' && wasDown.current)) wasDown.current = true;
    else if (aiState === 'available' && wasDown.current) {
      wasDown.current = false;
      setRecovered(true);
      const timer = setTimeout(() => setRecovered(false), 6000);
      return () => clearTimeout(timer);
    }
  }, [aiState]);
  if (recovered) {
    return (
      <div className="ai-banner ai-recovered" role="status">
        <strong>AI is back.</strong> Failed turns can be retried.
      </div>
    );
  }
  if (aiState === 'available') return null;
  const model = health?.inference.model ?? 'the model';
  return (
    <div className={`ai-banner ai-${aiState}`} role="status">
      {aiState === 'loading' ? (
        <span>
          <strong>AI loading.</strong> {model} is starting up; this can take 5 to 10 minutes after a restart. You can keep
          typing; your turn is kept.
        </span>
      ) : (
        <span>
          <strong>AI unavailable.</strong> {lastError ? `Health check failed: ${lastError}.` : `${model} is not reachable.`}{' '}
          Your messages are saved and can be retried.
        </span>
      )}
    </div>
  );
}
